<mat-form-field class="tag-autocomplete-field" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipGrid aria-label="Tag selection">
    @for (tag of selectItems; track tag) {
    <mat-chip-row (removed)="removeOption(tag)">
      {{ tag }}
      <button matChipRemove [attr.aria-label]="'remove ' + tag">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    }
    <input
      #tagInput
      placeholder="Type to search or add tags..."
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="false"
      [matAutocomplete]="auto"
      [formControl]="tagInputControl"
      (matChipInputTokenEnd)="addOption($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete 
    #auto="matAutocomplete" 
    (optionSelected)="onTagSelected($event)">
    @if (filteredTags.length > 0) {
      @for (tag of filteredTags; track tag) {
        <mat-option [value]="tag">{{ tag }}</mat-option>
      }
    } @else {
      @if (tagInputControl.value && tagInputControl.value.trim().length > 0 && !selectItems.includes(tagInputControl.value.trim())) {
        <mat-option [value]="tagInputControl.value.trim()">
          Add "{{ tagInputControl.value.trim() }}"
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
